export const UPDATE_TYPES = {
  MAJOR: "major",
  MINOR: "minor",
  PATCH: "patch",
} as const;

export const UPDATE_TYPES_OPTIONS = [
  { value: UPDATE_TYPES.MAJOR, label: "Breaking change" },
  { value: UPDATE_TYPES.MINOR, label: "Adds or edits fields" },
  { value: UPDATE_TYPES.PATCH, label: "Fixes logic without any input modification" },
];

export const UPDATE_TYPE_TO_WARNING_MAP = {
  [UPDATE_TYPES.MAJOR]:
    "It is required that a developer performs some code adaptation to prevent a system crash.",
  [UPDATE_TYPES.MINOR]: "Adding/removing values for existing fields could require code adaptation.",
  [UPDATE_TYPES.PATCH]: null,
} as const;

export const CLIENT_MODEL_FILENAME_EXAMPLE = "eo_new_recommendation_v3_10.xbl";

export const CLIENT_VERSION_NOT_IDENTIFIED_MESSAGE = `The client version could not be identified from the file name. Rename the file to follow the <model_family>_v<major>_<minor> convention, for example ${CLIENT_MODEL_FILENAME_EXAMPLE}.`;

export const PERSONIFY_REWARD_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Sending", value: "sending" },
  { label: "Succeeded", value: "succeeded" },
  { label: "Failed", value: "failed" },
  { label: "Abandoned", value: "abandoned" },
];

export const PERSONIFY_REWARD_EVENT_TYPE_OPTIONS = [
  { label: "Registration", value: "registration" },
  { label: "Login", value: "login" },
];

export const DETACH_CONFIRMATION_WORDS = [
  "DELETE",
  "DETACH",
  "CONFIRM",
  "UNLINK",
  "REMOVE",
] as const;
